<template>
  <div class="pk-flip-page pk-account-panel">
    <section class="pk-flip-layout">
      <main class="pk-flip-panel pk-flip-active">
        <header class="pk-flip-panel-head">
          <div>
            <span>等待中的对局</span>
            <h1>翻箱 1 VS 1</h1>
          </div>
          <div class="pk-flip-panel-actions">
            <button class="how" @click="openPanel('guide')">玩法介绍</button>
            <button class="create" @click="openPanel('create')">创建对局</button>
          </div>
        </header>

        <article v-for="room in rooms" :key="room.id" class="pk-flip-row">
          <div class="pk-flip-user">
            <div class="pk-flip-ring" :class="'tone-' + room.tone">
              <img v-if="room.left.img" :src="room.left.img" alt="" />
              <span v-else class="pk-flip-avatar-letter">{{ room.left.name.slice(0, 1) }}</span>
            </div>
            <div>
              <strong>{{ room.left.name }}</strong>
              <span>{{ room.caseCount }} 个箱子</span>
            </div>
          </div>

          <strong class="pk-flip-price">{{ room.price }}</strong>

          <div class="pk-flip-case-stack">
            <span v-for="(item, index) in room.cases" :key="index">
              <img :src="item.img" alt="" />
            </span>
          </div>

          <button class="pk-flip-join" @click="notify">加入</button>
          <button class="pk-flip-mini" @click="notify"></button>
        </article>
        <div v-if="!rooms.length" class="pk-flip-empty">当前暂无可加入的翻箱对局</div>
      </main>

      <aside class="pk-flip-panel pk-flip-progress">
        <header class="pk-flip-panel-head">
          <div>
            <span>{{ historyTitle }}</span>
          </div>
          <div class="pk-flip-panel-actions">
            <button class="how" :class="{ active: historyTab === 'progress' }" @click="historyTab = 'progress'">进行中</button>
            <button class="create" :class="{ active: historyTab === 'history' }" @click="historyTab = 'history'">全部历史</button>
            <button class="how" :class="{ active: historyTab === 'mine' }" @click="historyTab = 'mine'">我的历史</button>
          </div>
        </header>

        <article v-if="historyTab === 'progress'" v-for="game in progressGames" :key="game.id" class="pk-progress-row">
          <div class="pk-progress-ring red"></div>
          <strong>{{ game.left }}</strong>
          <div class="pk-progress-vs">VS</div>
          <strong>{{ game.right }}</strong>
          <div class="pk-progress-ring blue"></div>
          <button class="pk-flip-mini" @click="notify"></button>
        </article>

        <article v-if="historyTab !== 'progress'" v-for="item in visibleHistory" :key="item.id" class="pk-progress-row pk-history-row">
          <span>{{ item.id }}</span>
          <strong>{{ item.winner }}</strong>
          <em>{{ item.price }}</em>
        </article>
        <div v-if="historyTab === 'progress' && progressGames.length" class="pk-progress-fill"></div>
        <div v-if="historyTab === 'progress' && !progressGames.length" class="pk-flip-empty">当前暂无进行中的翻箱对局</div>
        <div v-if="historyTab !== 'progress' && !visibleHistory.length" class="pk-flip-empty">暂无可展示的翻箱历史</div>
      </aside>
    </section>

    <div v-if="panel" class="pk-flip-modal" @click.self="closePanel">
      <section class="pk-flip-modal-card" :class="{ create: panel === 'create' }">
        <button class="pk-flip-modal-close" @click="closePanel">×</button>
        <template v-if="panel === 'guide'">
          <span>玩法介绍</span>
          <h2>翻箱 1 VS 1</h2>
          <ol class="pk-flip-guide-list">
            <li><b>创建对局</b><p>选择阵营、加入对局箱子并设置房间有效时间。</p></li>
            <li><b>等待玩家</b><p>另一位玩家加入后，双方以相同的箱子清单进入翻箱流程。</p></li>
            <li><b>自动打开箱子</b><p>每轮箱子依次开启；真实结果、结算和饰品归属完全使用后端规则。</p></li>
          </ol>
        </template>
        <template v-else>
          <header class="pk-flip-create-head">
            <div>
              <span>创建对局</span>
              <h2>翻箱 1 VS 1</h2>
            </div>
            <small>每个阵营的获胜机会均为 50%</small>
          </header>

          <div class="pk-flip-create-step">
            <strong><i>1</i>选择阵营</strong>
            <div class="pk-flip-side-options">
              <button :class="{ active: createSide === 'blue' }" @click="createSide = 'blue'">
                <span class="pk-flip-side-orbit blue"></span>
                蓝色阵营
              </button>
              <em>VS</em>
              <button :class="{ active: createSide === 'red' }" @click="createSide = 'red'">
                <span class="pk-flip-side-orbit red"></span>
                红色阵营
              </button>
            </div>
          </div>

          <div class="pk-flip-create-step">
            <strong><i>2</i>选择箱子</strong>
            <div class="pk-flip-create-cases">
              <button
                v-for="item in createCases"
                :key="item.id"
                :class="{ active: selectedCreateCases.includes(item.id) }"
                @click="toggleCreateCase(item.id)"
              >
                <span class="pk-flip-case-check">{{ selectedCreateCases.includes(item.id) ? '✓' : '+' }}</span>
                <img :src="item.img" alt="" />
                <b>{{ item.name }}</b>
                <small>价格待接口</small>
              </button>
            </div>
          </div>

          <div class="pk-flip-create-step pk-flip-lifetime-step">
            <strong><i>3</i>对局有效时间</strong>
            <div class="pk-flip-lifetime-options">
              <button
                v-for="item in createLifetimes"
                :key="item.value"
                :class="{ active: createLifetime === item.value }"
                @click="createLifetime = item.value"
              >
                {{ item.label }}
              </button>
            </div>
          </div>

          <footer class="pk-flip-create-summary">
            <div><span>已选箱子</span><strong>{{ selectedCreateCases.length }} 个</strong></div>
            <div><span>对局价格</span><strong>-- <i></i></strong></div>
            <p>创建、扣减和结算接口尚未提供，当前不会提交任何资金或库存变更。</p>
            <button class="pk-flip-modal-action" @click="notify">创建对局</button>
          </footer>
        </template>
      </section>
    </div>

    <section class="pk-flip-mobile-history">
      <article v-for="item in history" :key="item.id">
        <span>{{ item.id }}</span>
        <strong>{{ item.winner }}</strong>
        <em>{{ item.price }}</em>
      </article>
    </section>
  </div>
</template>

<script>
export default {
  name: "CaseFlip",
  data() {
    const casePurple = require("../assets/hotpizza/hp-case-purple-transparent.png");
    const caseOrange = require("../assets/hotpizza/hp-case-orange.png");
    const caseGreen = require("../assets/hotpizza/hp-case-green.png");
    const caseBlue = require("../assets/hotpizza/hp-case-blue.png");
    const caseFire = require("../assets/hotpizza/hp-case-fire.png");
    const caseCrystal = require("../assets/hotpizza/hp-case-crystal.png");
    return {
      historyTab: "progress",
      panel: "",
      createSide: "blue",
      createLifetime: 6,
      createLifetimes: [
        { value: 1, label: "1 小时" },
        { value: 6, label: "6 小时" },
        { value: 12, label: "12 小时" },
        { value: 24, label: "24 小时" },
      ],
      createCases: [
        { id: "purple", name: "紫晶箱", img: casePurple },
        { id: "orange", name: "熔岩箱", img: caseOrange },
        { id: "green", name: "翡翠箱", img: caseGreen },
        { id: "blue", name: "极寒箱", img: caseBlue },
        { id: "fire", name: "烈焰箱", img: caseFire },
        { id: "crystal", name: "水晶箱", img: caseCrystal },
      ],
      selectedCreateCases: ["purple"],
      // Backend does not provide case-flip room, history, or settlement APIs yet.
      rooms: [],
      progressGames: [],
      history: [],
      myHistory: [],
    };
  },
  computed: {
    historyTitle() {
      if (this.historyTab === "progress") return "进行中的对局";
      return this.historyTab === "mine" ? "我的对局历史" : "全部对局历史";
    },
    visibleHistory() {
      return this.historyTab === "mine" ? this.myHistory : this.history;
    },
  },
  methods: {
    openPanel(panel) {
      this.panel = panel;
    },
    closePanel() {
      this.panel = "";
    },
    toggleCreateCase(id) {
      const index = this.selectedCreateCases.indexOf(id);
      if (index === -1) {
        this.selectedCreateCases.push(id);
      } else if (this.selectedCreateCases.length > 1) {
        this.selectedCreateCases.splice(index, 1);
      }
    },
    notify() {
      this.$message({
        message: "翻箱玩法暂未开放。",
        type: "info",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.pk-flip-page {
  min-height: calc(100vh - 198px);
  padding: 0 0 80px;
  color: #f5f7ff;
  background: #1f212c;
}

button {
  font-family: inherit;
  cursor: pointer;
}

.pk-flip-layout {
  width: 100%;
  max-width: 1540px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(560px, 0.92fr) minmax(420px, 0.98fr);
}

.pk-flip-panel {
  min-height: 900px;
  background: #232532;
  border-left: 1px solid rgba(255, 255, 255, 0.015);
}

.pk-flip-empty {
  min-height: 180px;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8f98aa;
  font-size: 14px;
  font-weight: 900;
  text-align: center;
}

.pk-flip-panel-head {
  height: 89px;
  padding: 0 30px 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  background: linear-gradient(180deg, rgba(54, 45, 106, 0.58), rgba(38, 39, 63, 0.36)), #242634;
  border-bottom: 1px solid rgba(255, 255, 255, 0.035);
}

.pk-flip-panel-head span {
  display: block;
  color: #ffd25b;
  font-size: 16px;
  line-height: 1;
  font-weight: 1000;
}

.pk-flip-panel-head h1 {
  margin: 10px 0 0;
  color: #f3f5ff;
  font-size: 13px;
  line-height: 1;
  font-weight: 1000;
}

.pk-flip-panel-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pk-flip-panel-head button {
  height: 38px;
  border-radius: 20px;
  color: #fff;
  font-size: 13px;
  font-weight: 1000;
}

.pk-flip-panel-head .how {
  width: 110px;
  background: transparent;
  border: 1px solid #7c61ff;
}

.pk-flip-panel-head .create {
  min-width: 140px;
  padding: 0 26px;
  background: #8066ff;
  border: 0;
}

.pk-flip-panel-head .how.active,
.pk-flip-panel-head .create.active {
  color: #fff7df;
  border-color: #ffbd42;
  background: rgba(255, 189, 66, 0.13);
  box-shadow: inset 0 0 0 1px rgba(255, 189, 66, 0.1);
}

.pk-flip-row {
  height: 70px;
  display: grid;
  grid-template-columns: 170px 92px minmax(150px, 1fr) 66px 34px;
  align-items: center;
  gap: 10px;
  padding: 0 18px 0 8px;
  background: #252733;
  border-bottom: 1px solid rgba(255, 255, 255, 0.012);
}

.pk-flip-row:nth-child(2n + 1),
.pk-progress-row:nth-child(2n + 1),
.pk-progress-fill {
  background: #20222d;
}

.pk-flip-user {
  min-width: 0;
  display: grid;
  grid-template-columns: 66px minmax(0, 1fr);
  gap: 14px;
  align-items: center;
}

.pk-flip-ring,
.pk-progress-ring {
  border-radius: 50%;
  background: #202330;
  border: 2px solid #1d74ff;
}

.pk-flip-ring {
  width: 50px;
  height: 50px;
  display: grid;
  place-items: center;
}

.pk-flip-ring.tone-red {
  border-color: #c72135;
}

.pk-flip-ring.tone-blue {
  border-color: #1d74ff;
}

.pk-flip-ring img {
  width: 42px;
  height: 42px;
  object-fit: contain;
  border-radius: 50%;
}

.pk-flip-avatar-letter {
  color: #ecf6ff;
  font-size: 18px;
  font-weight: 1000;
  line-height: 1;
  text-transform: uppercase;
}

.pk-flip-user strong {
  display: block;
  overflow: hidden;
  color: #f1f4ff;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 1000;
}

.pk-flip-user span {
  display: block;
  margin-top: 5px;
  color: #9ba3b5;
  font-size: 13px;
  font-weight: 900;
}

.pk-flip-price,
.pk-progress-row strong {
  color: #ffc13a;
  font-size: 16px;
  font-weight: 1000;
}

.pk-flip-case-stack {
  height: 60px;
  display: flex;
  align-items: stretch;
  overflow: hidden;
}

.pk-flip-case-stack span {
  width: 68px;
  min-width: 68px;
  height: 60px;
  display: grid;
  place-items: center;
  background: #2b2e3a;
  border-right: 1px solid #20222d;
}

.pk-flip-case-stack img {
  max-width: 64px;
  max-height: 48px;
  object-fit: contain;
  filter: drop-shadow(0 11px 12px rgba(0, 0, 0, 0.42));
}

.pk-flip-join {
  width: 56px;
  height: 34px;
  color: #ffd768;
  background: transparent;
  border: 1px solid #ffc13a;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 1000;
}

.pk-flip-mini {
  width: 16px;
  height: 34px;
  padding: 0;
  background: transparent;
  border: 1px solid #ff6b16;
  border-radius: 4px;
}

.pk-flip-mini::after {
  width: 7px;
  height: 7px;
  display: block;
  margin: 0 auto;
  content: "";
  border-top: 2px solid currentColor;
  border-right: 2px solid currentColor;
  transform: rotate(45deg);
}

.pk-progress-row {
  height: 70px;
  display: grid;
  grid-template-columns: 56px 82px 50px 82px 56px 34px;
  align-items: center;
  gap: 12px;
  padding: 0 20px 0 10px;
  background: #252733;
}

.pk-progress-ring {
  width: 48px;
  height: 48px;
}

.pk-progress-ring.red {
  border-color: #c72135;
}

.pk-progress-ring.blue {
  border-color: #1d74ff;
}

.pk-progress-vs {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  color: #ffc13a;
  border: 1px solid #ffc13a;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 1000;
}

.pk-progress-fill {
  min-height: 700px;
}

.pk-flip-mobile-history {
  display: none;
}

.pk-history-row {
  grid-template-columns: 1.1fr 1fr 0.7fr;
}

.pk-history-row span,
.pk-history-row em {
  color: #aeb7c8;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
}

.pk-history-row em {
  color: #ffbd42;
  text-align: right;
}

.pk-flip-modal {
  position: fixed;
  z-index: 9999;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(11, 12, 18, 0.76);
}

.pk-flip-modal-card {
  width: 460px;
  max-width: 100%;
  position: relative;
  padding: 30px;
  color: #f7f1e4;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 137, 30, 0.13), transparent 48%),
    #242735;
  border: 1px solid rgba(238, 216, 181, 0.28);
  border-radius: 9px;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.46);
}

.pk-flip-modal-card.create {
  width: 920px;
  max-height: calc(100vh - 48px);
  padding: 0;
  overflow: auto;
  background:
    radial-gradient(ellipse at 50% 0, rgba(128, 72, 255, 0.15), transparent 42%),
    #20222f;
  border-color: #393d50;
}

.pk-flip-create-head {
  min-height: 78px;
  padding: 22px 28px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #343748;
  box-sizing: border-box;
}

.pk-flip-create-head span,
.pk-flip-create-head h2 {
  display: block;
  margin: 0;
}

.pk-flip-create-head span {
  color: #ffbd42;
  font-size: 11px;
  font-weight: 1000;
  letter-spacing: 0.12em;
}

.pk-flip-create-head h2 {
  margin-top: 5px;
  color: #fff7df;
  font-size: 21px;
}

.pk-flip-create-head small {
  padding-right: 30px;
  color: #929bad;
  font-size: 12px;
  font-weight: 900;
}

.pk-flip-create-step {
  padding: 19px 28px 0;
}

.pk-flip-create-step > strong {
  display: flex;
  align-items: center;
  gap: 9px;
  color: #e8edf7;
  font-size: 13px;
}

.pk-flip-create-step > strong i {
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  color: #191b26;
  background: #ffbd42;
  border-radius: 50%;
  font-size: 11px;
  font-style: normal;
}

.pk-flip-side-options {
  margin-top: 13px;
  display: grid;
  grid-template-columns: 1fr 48px 1fr;
  align-items: center;
  gap: 10px;
}

.pk-flip-side-options > button {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #aeb7c8;
  background: #252837;
  border: 1px solid #34384a;
  border-radius: 7px;
  font-size: 14px;
  font-weight: 1000;
}

.pk-flip-side-options > button.active:first-child {
  color: #e8fbff;
  border-color: #2bd8ff;
  box-shadow: inset 0 0 28px rgba(43, 216, 255, 0.09), 0 0 20px rgba(43, 216, 255, 0.08);
}

.pk-flip-side-options > button.active:last-child {
  color: #fff0f2;
  border-color: #e05561;
  box-shadow: inset 0 0 28px rgba(224, 85, 97, 0.09), 0 0 20px rgba(224, 85, 97, 0.08);
}

.pk-flip-side-options > em {
  color: #747e91;
  font-size: 12px;
  font-style: normal;
  font-weight: 1000;
  text-align: center;
}

.pk-flip-side-orbit {
  width: 38px;
  height: 38px;
  border: 2px solid currentColor;
  border-radius: 50%;
  box-shadow: 0 0 18px currentColor;
}

.pk-flip-side-orbit.blue {
  color: #2bd8ff;
}

.pk-flip-side-orbit.red {
  color: #e05561;
}

.pk-flip-create-cases {
  margin-top: 13px;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 8px;
}

.pk-flip-create-cases > button {
  height: 138px;
  padding: 9px 7px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #dfe5ef;
  background:
    radial-gradient(circle at 50% 42%, rgba(126, 87, 255, 0.19), transparent 52%),
    #252837;
  border: 1px solid #34384a;
  border-radius: 7px;
}

.pk-flip-create-cases > button.active {
  border-color: #ffbd42;
  box-shadow: inset 0 0 24px rgba(255, 189, 66, 0.08), 0 0 18px rgba(255, 152, 24, 0.09);
}

.pk-flip-create-cases img {
  width: 96px;
  height: 78px;
  object-fit: contain;
  mix-blend-mode: screen;
  filter: drop-shadow(0 12px 13px rgba(0, 0, 0, 0.42));
}

.pk-flip-create-cases b {
  max-width: 100%;
  overflow: hidden;
  color: #edf1f8;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pk-flip-create-cases small {
  margin-top: 3px;
  color: #7f899b;
  font-size: 10px;
}

.pk-flip-case-check {
  width: 20px;
  height: 20px;
  position: absolute;
  z-index: 2;
  top: 7px;
  right: 7px;
  display: grid;
  place-items: center;
  color: #9ba4b6;
  background: #1c1f2b;
  border: 1px solid #404458;
  border-radius: 50%;
  font-size: 12px;
}

.pk-flip-create-cases button.active .pk-flip-case-check {
  color: #1c1f2b;
  background: #ffbd42;
  border-color: #ffbd42;
}

.pk-flip-lifetime-step {
  padding-bottom: 18px;
}

.pk-flip-lifetime-options {
  margin-top: 13px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.pk-flip-lifetime-options button {
  height: 40px;
  color: #aeb7c8;
  background: #252837;
  border: 1px solid #34384a;
  border-radius: 6px;
  font-weight: 900;
}

.pk-flip-lifetime-options button.active {
  color: #fff1cd;
  border-color: #ffbd42;
  background: rgba(255, 189, 66, 0.08);
}

.pk-flip-create-summary {
  min-height: 94px;
  padding: 17px 28px;
  display: grid;
  grid-template-columns: 120px 150px 1fr 142px;
  align-items: center;
  gap: 18px;
  border-top: 1px solid #343748;
  background: #1c1f2b;
  box-sizing: border-box;
}

.pk-flip-create-summary div span,
.pk-flip-create-summary div strong {
  display: block;
}

.pk-flip-create-summary div span {
  color: #737d90;
  font-size: 10px;
  font-weight: 1000;
}

.pk-flip-create-summary div strong {
  margin-top: 4px;
  color: #fff2d0;
  font-size: 16px;
}

.pk-flip-create-summary div strong i {
  width: 13px;
  height: 13px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-flip-create-summary p {
  color: #70798b;
  font-size: 10px;
  line-height: 1.5;
}

.pk-flip-create-summary .pk-flip-modal-action {
  width: 142px;
  height: 44px;
  margin-top: 0;
}

.pk-flip-guide-list {
  margin: 22px 0 0;
  padding: 0;
  list-style: none;
}

.pk-flip-guide-list li {
  padding: 14px 0;
  border-top: 1px solid #343748;
}

.pk-flip-guide-list b {
  color: #fff2d0;
  font-size: 14px;
}

.pk-flip-guide-list p {
  margin-top: 5px;
}

.pk-flip-modal-card > span {
  color: #ffbd42;
  font-size: 12px;
  font-weight: 1000;
  letter-spacing: 0.1em;
}

.pk-flip-modal-card h2 {
  margin: 8px 0 14px;
  font-size: 24px;
}

.pk-flip-modal-card p {
  margin: 0;
  color: #b5becd;
  font-size: 14px;
  line-height: 1.8;
}

.pk-flip-modal-close {
  width: 34px;
  height: 34px;
  position: absolute;
  top: 10px;
  right: 10px;
  color: #f4ead8;
  background: transparent;
  border: 0;
  font-size: 28px;
  line-height: 1;
}

.pk-flip-modal-action {
  height: 40px;
  margin-top: 22px;
  padding: 0 18px;
  color: #fff7df;
  background: linear-gradient(180deg, #ff971f, #f26b00);
  border: 0;
  border-radius: 6px;
  font-weight: 1000;
}

@media (max-width: 1280px) {
  .pk-flip-layout {
    grid-template-columns: 1fr;
  }

  .pk-flip-panel {
    min-height: auto;
  }

  .pk-progress-fill {
    min-height: 260px;
  }
}

@media (max-width: 760px) {
  .pk-flip-layout {
    display: block;
  }

  .pk-flip-panel-head {
    height: auto;
    padding: 18px;
    align-items: flex-start;
    flex-direction: column;
  }

  .pk-flip-row,
  .pk-progress-row {
    height: auto;
    grid-template-columns: 1fr;
    padding: 14px;
  }

  .pk-flip-case-stack {
    width: 100%;
  }

  .pk-flip-create-cases {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .pk-flip-create-summary {
    grid-template-columns: 1fr 1fr;
  }

  .pk-flip-create-summary p,
  .pk-flip-create-summary .pk-flip-modal-action {
    width: 100%;
    grid-column: 1 / -1;
  }
}

/* 2026-07-05 exact-pass: caseflip dense two-column target layout. */
.pk-caseflip-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  background:
    radial-gradient(ellipse at 48% 180px, rgba(128, 72, 255, 0.08), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1d29 430px, #171923 100%) !important;
}

.pk-flip-shell {
  max-width: none !important;
  padding: 0 24px 94px !important;
}

.pk-flip-header {
  height: 72px !important;
  border-bottom: 1px solid #2b2d3c !important;
}

.pk-flip-header h1 {
  color: #f4ead8 !important;
  font-size: 24px !important;
}

.pk-flip-layout {
  margin-top: 18px !important;
  grid-template-columns: minmax(620px, 1.1fr) minmax(430px, 0.9fr) !important;
  gap: 14px !important;
}

.pk-flip-panel {
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background: #20222f !important;
  box-shadow: none !important;
  overflow: hidden !important;
}

.pk-flip-panel-head {
  height: 62px !important;
  padding: 0 16px !important;
  background: #252837 !important;
  border-bottom: 1px solid #2b2d3c !important;
}

.pk-flip-panel-head h2 {
  color: #f4ead8 !important;
  font-size: 16px !important;
}

.pk-flip-panel-head .how,
.pk-flip-panel-head .create {
  height: 38px !important;
  border-radius: 6px !important;
  color: #ecd8b8 !important;
}

.pk-flip-panel-head .how {
  border-color: rgba(236, 216, 184, 0.34) !important;
}

.pk-flip-panel-head .create {
  color: #fff7df !important;
  background: linear-gradient(180deg, #ff971f, #f26b00) !important;
}

.pk-flip-row {
  height: 66px !important;
  grid-template-columns: 176px 86px minmax(150px, 1fr) 64px 34px !important;
  background: #252837 !important;
  border-bottom: 1px solid rgba(67, 73, 96, 0.55) !important;
}

.pk-flip-row:nth-child(2n + 1),
.pk-progress-row:nth-child(2n + 1),
.pk-progress-fill {
  background: #20222f !important;
}

.pk-flip-ring,
.pk-progress-ring {
  border-color: #ecd8b8 !important;
  background: #1c1d29 !important;
}

.pk-flip-ring.tone-red,
.pk-progress-ring.red {
  border-color: #e05561 !important;
}

.pk-flip-ring.tone-blue,
.pk-progress-ring.blue {
  border-color: #2bd8ff !important;
}

.pk-flip-price,
.pk-progress-row strong {
  color: #ffbd42 !important;
}

.pk-flip-case-stack span {
  background:
    radial-gradient(circle at 50% 45%, rgba(236, 216, 184, 0.1), transparent 62%),
    #282b38 !important;
  border-right: 1px solid #20222f !important;
}

.pk-flip-case-stack img {
  filter:
    drop-shadow(0 12px 14px rgba(0, 0, 0, 0.44))
    drop-shadow(0 0 16px rgba(255, 138, 31, 0.12)) !important;
}

.pk-flip-join,
.pk-flip-mini {
  color: #ecd8b8 !important;
  border-color: rgba(236, 216, 184, 0.48) !important;
}

.pk-progress-row {
  height: 66px !important;
  background: #252837 !important;
  border-bottom: 1px solid rgba(67, 73, 96, 0.55) !important;
}

.pk-progress-vs {
  color: #ecd8b8 !important;
  border-color: rgba(236, 216, 184, 0.48) !important;
}

@media (max-width: 1280px) {
  .pk-flip-layout {
    grid-template-columns: 1fr !important;
  }
}

.pk-flip-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 0 24px 94px !important;
  background:
    radial-gradient(ellipse at 48% 180px, rgba(128, 72, 255, 0.08), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1d29 430px, #171923 100%) !important;
}

.pk-flip-page.pk-account-panel .pk-flip-layout {
  max-width: none !important;
  margin-top: 18px !important;
  grid-template-columns: minmax(620px, 1.1fr) minmax(430px, 0.9fr) !important;
  gap: 14px !important;
}

.pk-flip-page.pk-account-panel .pk-flip-panel {
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background: #20222f !important;
  box-shadow: none !important;
  overflow: hidden !important;
}

@media (max-width: 1280px) {
  .pk-flip-page.pk-account-panel .pk-flip-layout {
    grid-template-columns: 1fr !important;
  }
}
</style>

<style lang="less">
/* Lift the route content stacking context while the create/guide overlay is open. */
body:has(.pk-flip-modal) .maringtop75.backColor {
  z-index: 9998 !important;
}
</style>

<style lang="less">
/* 2026-07-05 exact-pass: case flip list and progress panels. */
.pk-flip-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 18px 24px 96px !important;
  background:
    radial-gradient(ellipse at 38% 180px, rgba(128, 72, 255, 0.09), transparent 460px),
    radial-gradient(ellipse at 70% 260px, rgba(253, 107, 1, 0.07), transparent 440px),
    #191b26 !important;
}

.pk-flip-page.pk-account-panel .pk-flip-layout {
  width: 100% !important;
  max-width: none !important;
  margin-top: 0 !important;
  grid-template-columns: minmax(650px, 1.12fr) minmax(420px, 0.88fr) !important;
  gap: 8px !important;
}

.pk-flip-page.pk-account-panel .pk-flip-panel {
  border-color: #2b2d3c !important;
  border-radius: 8px !important;
  background: #20222f !important;
  box-shadow: none !important;
}

.pk-flip-page.pk-account-panel .pk-flip-panel-head {
  height: 64px !important;
  border-bottom: 1px solid #2b2d3c !important;
  background:
    radial-gradient(ellipse at 12% 50%, rgba(253, 107, 1, 0.1), transparent 42%),
    #20222f !important;
}

.pk-flip-page.pk-account-panel .pk-flip-row,
.pk-flip-page.pk-account-panel .pk-progress-row {
  height: 72px !important;
  background: #252837 !important;
}

.pk-flip-page.pk-account-panel .pk-flip-row:nth-child(2n + 1),
.pk-flip-page.pk-account-panel .pk-progress-row:nth-child(2n + 1) {
  background: #20222f !important;
}

.pk-flip-page.pk-account-panel .pk-flip-case-stack span {
  background:
    radial-gradient(circle at 50% 45%, rgba(253, 107, 1, 0.1), transparent 60%),
    #282b38 !important;
}

.pk-flip-page.pk-account-panel .pk-flip-join,
.pk-flip-page.pk-account-panel .pk-progress-vs {
  min-width: 82px !important;
  height: 34px !important;
  border-radius: 6px !important;
}

.pk-flip-page.pk-account-panel {
  padding: 0 0 96px !important;
  background: #1f212c !important;
}

.pk-flip-page.pk-account-panel .pk-flip-layout {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  gap: 0 !important;
}

.pk-flip-page.pk-account-panel .pk-flip-panel {
  min-height: 900px !important;
  border: 0 !important;
  border-radius: 0 !important;
  border-right: 1px solid #2b2d3c !important;
}

.pk-flip-page.pk-account-panel .pk-flip-progress {
  border-right: 0 !important;
}

.pk-flip-page.pk-account-panel .pk-flip-panel-head {
  height: 74px !important;
  padding: 0 30px 0 20px !important;
  background: linear-gradient(180deg, rgba(55, 44, 110, 0.62), rgba(35, 37, 54, 0.46)), #20222f !important;
}

/* Keep an unconfigured room feed compact; real rows still grow the columns naturally. */
.pk-flip-page.pk-account-panel .pk-flip-panel {
  min-height: 300px !important;
}

@media (max-width: 1280px) {
  .pk-flip-page.pk-account-panel {
    padding: 18px 24px 96px !important;
  }

  .pk-flip-page.pk-account-panel .pk-flip-panel {
    min-height: auto !important;
    border: 1px solid #2b2d3c !important;
    border-radius: 8px !important;
  }
}
</style>
